module.exports = __webpack_public_path__ + "static/media/icon_value_summary.e9f1cdba.svg";